import request from '../request'
// 获取会员卡信息
const getCardData = (data) => {
  return request.post('/api/wx/getCardInfo', data)
}
// 根据手机号获取会员卡信息
const getEmployeeInfo = (data) => {
  return request.post('/api/wx/getEmployeeInfo', data)
}
// 发送验证码
const sendSmsCode = (data) => {
  return request.post('/api/wx/sendSmsCode', data)
}

// 对象数组
export default {
  getCardData,
  getEmployeeInfo,
  sendSmsCode
}
